import {AutocompleteInput, DateInput, ReferenceInput, SimpleForm,} from "react-admin";
import {FormProps} from "../../shared/types";
import {initInput} from "../../shared/utils";
import {Grid} from "@material-ui/core";
import {CustomToolbar} from "../../components/CustomToolbar";
import {ReferenceInputInvoice} from "../../components/reference-inputs/ReferenceInputInvoice";

export const BankReceiptForm = (props: FormProps) => {

  return (
    <SimpleForm
      {...props}
      toolbar={
        <CustomToolbar canEdit={props.canEdit} canDelete={props.canDelete} />
      }
    >
      <Grid spacing={2} container alignItems="center" style={{ width: "100%" }}>
        <Grid item xs={6}>
          <ReferenceInput
              {...initInput("payment_schedule_id", props.fieldOptions, props.canEdit)}
              reference="autocomplete/payment_schedule" label="Dati fattura">
              <AutocompleteInput optionText="label" />
          </ReferenceInput>
        </Grid>
        <Grid item xs={6}>
          <DateInput {...initInput("expiration_date", props.fieldOptions, props.canEdit)} />
        </Grid>
        
      </Grid>
    </SimpleForm>
  );
};
